// extracted by mini-css-extract-plugin
module.exports = {"countBox":"HomeInformationSection_countBox__cFb7l","container":"HomeInformationSection_container__8U7kY"};